// import { lockBody, unlockBody } from "@plugins";
import { lockBody, unlockBody } from "../modules/scroll-locker";

export class FilterPopup {
    constructor(element, options) {
        Object.assign(this);

        this._setDefaults(options);

        this.element = element;
        this.openFilterBtn = document.querySelector(".js-filter-modal-trigger");
        this.closeFilter = document.querySelectorAll(".js-filter-close");

        if (this.openFilterBtn) {
            this.openFilterBtn.addEventListener("click", (e) => {
                e.preventDefault();
                this.open(this.element);
            });
        }

        if (this.closeFilter.length > 0) {
            this.closeFilter.forEach((el) => {
                el.addEventListener("click", () => {
                    this.close(this.element);
                });
            });
        }
    }

    _setDefaults(options) {
        const defaults = {
            isOpen: {
                state: false,
            },
        };
        Object.assign(this, defaults, options);
    }

    open(element) {
        if (!this.isOpen.state) {
            this.isOpen.state = true;
            element.classList.add("opened");
            lockBody(this.element, { reserveScrollBarGap: true });
        }
    }

    close(element) {
        this.isOpen.state = false;
        element.classList.remove("opened");
        unlockBody();
    }
}